export default {
    getHeaderFields: state => state.headerFields,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions
}
